export namespace ApiUrlConfigKeys {
  export const AsrServicesUrl = 'asr.serviceUrl';
  export const ServicesAuthUrl = 'services.auth.url';
  export const ServicesAuthTenant = 'services.auth.tenant';
  export const AsrFileStorageUrl = 'asr.fileStorageUrl';
  export const AsrPeoplePickerfromNIHAD = 'asr.peoplePickerfromNIHAD';
}

export namespace AsrRoutePath {
  export const ASR_URL = 'asr';
  export const HOME_URL = 'home';
  export const VIRTUAL_TOURS_URL = 'virtualTours';
  export const PROGRAM_LEAD_SURVEY_URL = 'programLeadSurvey/:programName/:programLeadId';
  export const BRANCH_SURVEY_URL = 'branchSurvey';
  export const SURVEY_DASHBOARD_URL = 'surveyDashboard';
  export const SURVEY_USERS_DASHBOARD_URL = 'leadSurveyUsersDashboard';
  export const SURVEY_SETTINGS_DASHBOARD_URL = 'surveySettingsDashboard';
  export const USER_DASHBOARD_URL = 'userDashboard';
  export const USER_DASHBOARD_URL_ID = 'userDashboard/:userId';
  export const OSD_URL = 'osd';
  export const REVIEWER_URL = 'reviewer';
  export const REVIEWS_URL = 'reviews';
  export const REVIEW_URL = 'review/:reviewId';
  export const OVERVIEW_URL = 'overview';
  export const MILESTONES_URL = 'milestones';
  export const MATERIALS_URL = 'materials';
  export const PROGRAMSTAFF_URL = 'programStaff';
  export const REVIEWERS_URL = 'reviewers';
  export const REPORTS_URL = 'reports';
  export const DASHBOARD_URL = 'dashboard';
  export const REVIEWER_CRITIQUESHEETS_URL = 'critiqueSheets';
  export const REVIEWER_PROGRAMREPORT_URL = 'programReport';
  export const OSD_CRITIQUESHEET_URL = 'critiqueSheet/:itemId';
  export const OSD_PROGRAMREPORT_URL = 'programReport/:itemId';
  export const PROFILE_SETTINGS_URL = 'https://asr-qa.ncats.nih.gov/_layouts/15/settings.aspx';
}

export const MESSAGE_CONSTANTS = {
  BIAS: {
    BIAS_AGREEMENT_FETCH_ERROR: 'Error fetching bias agreement.',
    READING_MATERIAL_FETCH_ERROR: 'Error fetching reading material.',
    VIRTUAL_TOUR_FETCH_ERROR: 'Error fetching virtual tours.',
    SAVE_RESPONSE_ERROR: 'Error submitting bias training confirmation.',
    SUBMIT_ERROR_MESSAGE: 'There was an error saving your response. Please try again.'
  }
};
